/**
 * @param props
 */

export default (props) => {
    return {
        show: true,
        customize: false,
        accepted: {},
        changed(type) {
            fetch('/service/dismiss?dismiss=cookie&type=' + type + '&data=' + (this.accepted[type] ? 1 : 0)).then(() => {});
        },
        dismiss() {
            fetch('/service/dismiss.json?dismiss=age-gate').then(() => {
                this.modules.display.cookies = false;
                this.service.age_gate.visible = false;
                this.service.banners.available = this.service.banners.discovered;
            });
        },
        mounted() {
            this.customize = this.modules.display.cookies;
            Object.values(this.service.cookiesModule.types).forEach(type => {
                this.accepted[type.value] = type.allowed;
            });
        }
    }
};